import React from 'react';
import { PrepBoth, PrepMilk, PrepWater } from './BuilderUiIcons';
import './PreparationMethodSelector.css';

const METHODS = [
  {
    value: 'water',
    label: 'Water-Based',
    Icon: PrepWater,
    description: 'Traditional tea brewing with hot water',
  },
  {
    value: 'milk',
    label: 'Milk-Based',
    Icon: PrepMilk,
    description: 'Chai-style with milk (like masala chai)',
  },
  {
    value: 'both',
    label: 'Both Water & Milk',
    Icon: PrepBoth,
    description: 'Versatile ingredients for any preparation',
  },
];

function PreparationMethodSelector({ selected, onChange }) {
  return (
    <div className="preparation-selector">
      {METHODS.map((method) => {
        const Icon = method.Icon;
        return (
          <div
            key={method.value}
            className={`method-option ${selected === method.value ? 'selected' : ''}`}
            onClick={() => onChange(method.value)}
          >
            <div className="method-icon" aria-hidden>
              <Icon className="method-icon-svg" />
            </div>
            <div className="method-label">{method.label}</div>
            <div className="method-description">{method.description}</div>
          </div>
        );
      })}
    </div>
  );
}

export default PreparationMethodSelector;
